package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_invoice_data_InvoiceModule : Module get() = module {
	single() { _ -> com.essntl.features.invoice.data.repository.InvoiceRepositoryImpl(supabase=get()) } bind(com.essntl.features.invoice.domain.repository.InvoiceRepository::class)
	single() { _ -> com.essntl.features.invoice.data.supabase.InvoiceSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.invoice.data.supabase.InvoiceSupabaseDataSource::class)
}
public val com.essntl.features.invoice.data.InvoiceModule.module : org.koin.core.module.Module get() = com_essntl_features_invoice_data_InvoiceModule
